// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/site_membership/v1/site_membership.proto (package fingertip.creator.site_membership.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateSiteMembershipRequest, CreateSiteMembershipResponse, DeleteSiteMembershipRequest, DeleteSiteMembershipResponse, GetSiteMemberProfileRequest, GetSiteMemberProfileResponse, GetSiteMemberProfilesRequest, GetSiteMemberProfilesResponse, GetSiteMembershipRequest, GetSiteMembershipResponse, GetSiteMembershipsRequest, GetSiteMembershipsResponse, GetWorkspaceSitesMembershipRequest, GetWorkspaceSitesMembershipResponse, UpdateSiteMembershipRequest, UpdateSiteMembershipResponse } from "./site_membership_pb.js";

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.UpdateSiteMembership
 */
export const updateSiteMembership = {
  localName: "updateSiteMembership",
  name: "UpdateSiteMembership",
  kind: MethodKind.Unary,
  I: UpdateSiteMembershipRequest,
  O: UpdateSiteMembershipResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.DeleteSiteMembership
 */
export const deleteSiteMembership = {
  localName: "deleteSiteMembership",
  name: "DeleteSiteMembership",
  kind: MethodKind.Unary,
  I: DeleteSiteMembershipRequest,
  O: DeleteSiteMembershipResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.CreateSiteMembership
 */
export const createSiteMembership = {
  localName: "createSiteMembership",
  name: "CreateSiteMembership",
  kind: MethodKind.Unary,
  I: CreateSiteMembershipRequest,
  O: CreateSiteMembershipResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.GetSiteMemberships
 */
export const getSiteMemberships = {
  localName: "getSiteMemberships",
  name: "GetSiteMemberships",
  kind: MethodKind.Unary,
  I: GetSiteMembershipsRequest,
  O: GetSiteMembershipsResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.GetSiteMemberProfile
 */
export const getSiteMemberProfile = {
  localName: "getSiteMemberProfile",
  name: "GetSiteMemberProfile",
  kind: MethodKind.Unary,
  I: GetSiteMemberProfileRequest,
  O: GetSiteMemberProfileResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.GetSiteMemberProfiles
 */
export const getSiteMemberProfiles = {
  localName: "getSiteMemberProfiles",
  name: "GetSiteMemberProfiles",
  kind: MethodKind.Unary,
  I: GetSiteMemberProfilesRequest,
  O: GetSiteMemberProfilesResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.GetSiteMembership
 */
export const getSiteMembership = {
  localName: "getSiteMembership",
  name: "GetSiteMembership",
  kind: MethodKind.Unary,
  I: GetSiteMembershipRequest,
  O: GetSiteMembershipResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};

/**
 * @generated from rpc fingertip.creator.site_membership.v1.SiteMembershipService.GetWorkspaceSitesMembership
 */
export const getWorkspaceSitesMembership = {
  localName: "getWorkspaceSitesMembership",
  name: "GetWorkspaceSitesMembership",
  kind: MethodKind.Unary,
  I: GetWorkspaceSitesMembershipRequest,
  O: GetWorkspaceSitesMembershipResponse,
  service: {
    typeName: "fingertip.creator.site_membership.v1.SiteMembershipService"
  }
};
